export const namespaced = true;

export const state = {
    perPages: [5, 15, 25, 50, 100, 150, 250],
    sorts: [
        {
            id: 0,
            name: 'Новые сначала',
            value: 'created_at',
            desc: true
        },
        {
            id: 1,
            name: 'Старые сначала',
            value: 'created_at',
            desc: false
        },
        {
            id: 2,
            name: 'По алфавиту',
            value: 'name',
            desc: false
        },
    ],
    settings: {},
    settingImages: {}
}

export const mutations = {
    FETCH_SETTINGS(state, settings) {
        state.settings = settings;
    },
    FETCH_SETTING_IMAGES(state, settingImages) {
        state.settingImages = settingImages;
    },
    SET_SETTING() { },
    SET_SETTINGS() { },
}

export const actions = {
    async fetch({ commit, dispatch }) {
        try {
            const res = (await axios.get(`/api/settings`)).data;
            commit('FETCH_SETTINGS', res.data);
            return res.data;
        } catch (error) {
            const notification = {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },
    async fetchAdmin({ commit, dispatch }) {
        try {
            const res = (await axios.get(`/api/admin/settings`)).data;
            commit('FETCH_SETTINGS', res.data);
            return res.data;
        } catch (error) {
            const notification = {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },
    async fetchSettingImages({ commit, dispatch }) {
        try {
            const res = await axios.get(`/api/get-setting-images`);
            commit('FETCH_SETTING_IMAGES', res.data);
            return res.data;
        } catch (error) {
            const notification = {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },

    async set({ commit, dispatch }, { key, value, notify = true }) {
        try {
            const res = (await axios.post(`/api/admin/settings`, { key, value })).data;
            commit('SET_SETTING');
            dispatch('fetch');
            if (notify) {
                const notification = {
                    type: 'success',
                    message: 'Настройка сохранена'
                }
                dispatch('notification/add', notification, { root: true })
            }
        } catch (error) {
            const notification = {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },

    async setSettings({ commit, dispatch }, data) {
        try {
            const res = (await axios.post(`/api/admin/save-settings`, data)).data;
            commit('SET_SETTINGS');
            dispatch('fetch');
            const notification = {
                type: 'success',
                message: 'Настройки сохранены'
            }
            dispatch('notification/add', notification, { root: true })
        } catch (error) {
            const notification = {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })

            if (error.response && error.response.data && error.response.data.errors) {
                for (const key in error.response.data.errors) {
                    if (Object.hasOwnProperty.call(error.response.data.errors, key)) {
                        const notification = {
                            type: 'error',
                            message: error.response.data.errors[key][0]
                        }
                        dispatch('notification/add', notification, { root: true })
                    }
                }
            }
        }
    },

    async saveSettingImages({ commit, dispatch }, data) {
        try {
            await axios.post(`/api/admin/save-setting-images`, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            commit('SET_SETTINGS');
            dispatch('fetch');
            const notification = {
                type: 'success',
                message: 'Загрузка прошла успешна'
            }
            dispatch('notification/add', notification, { root: true })
        } catch (error) {
            const notification = {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })

            if (error.response && error.response.data && error.response.data.errors) {
                for (const key in error.response.data.errors) {
                    if (Object.hasOwnProperty.call(error.response.data.errors, key)) {
                        const notification = {
                            type: 'error',
                            message: error.response.data.errors[key][0]
                        }
                        dispatch('notification/add', notification, { root: true })
                    }
                }
            }
        }
    },

    async sendTestMail({ dispatch }, { customer_email }) {
        try {
            const res = (await axios.post(`/api/admin/settings/mail/test`, { customer_email })).data;
            const notification = {
                type: 'success',
                message: res.message || 'Тестовое сообщение отправлено'
            }
            dispatch('notification/add', notification, { root: true })
            return res;
        } catch (error) {
            const notification = {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })

            if (error.response && error.response.data && error.response.data.errors) {
                for (const key in error.response.data.errors) {
                    if (Object.hasOwnProperty.call(error.response.data.errors, key)) {
                        const notification = {
                            type: 'error',
                            message: error.response.data.errors[key][0]
                        }
                        dispatch('notification/add', notification, { root: true })
                    }
                }
            }
        }
    },
}

export const getters = {
    settings(state) {
        return state.settings;
    },
}
